import React from 'react';

export default function FileDownloadIcon() {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4111 30.2441C24.7365 29.9186 25.2641 29.9186 25.5896 30.2441L29.167 33.8215L32.7444 30.2441C33.0698 29.9186 33.5975 29.9186 33.9229 30.2441C34.2484 30.5695 34.2484 31.0972 33.9229 31.4226L29.7562 35.5893C29.4308 35.9147 28.9032 35.9147 28.5777 35.5893L24.4111 31.4226C24.0856 31.0972 24.0856 30.5695 24.4111 30.2441Z"
        fill="#14B053"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.1663 20.8334C24.1037 20.8334 19.9997 24.9375 19.9997 30.0001C19.9997 35.0627 24.1037 39.1667 29.1663 39.1667C34.229 39.1667 38.333 35.0627 38.333 30.0001C38.333 24.9375 34.229 20.8334 29.1663 20.8334ZM18.333 30.0001C18.333 24.017 23.1833 19.1667 29.1663 19.1667C35.1494 19.1667 39.9997 24.017 39.9997 30.0001C39.9997 35.9832 35.1494 40.8334 29.1663 40.8334C23.1833 40.8334 18.333 35.9832 18.333 30.0001Z"
        fill="#14B053"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.1663 24.1667C29.6266 24.1667 29.9997 24.5398 29.9997 25.0001V35.0001C29.9997 35.4603 29.6266 35.8334 29.1663 35.8334C28.7061 35.8334 28.333 35.4603 28.333 35.0001V25.0001C28.333 24.5398 28.7061 24.1667 29.1663 24.1667Z"
        fill="#14B053"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3786 14.168C18.6994 14.1854 18.9816 14.3857 19.1039 14.6828L20.5389 18.1678C20.7141 18.5934 20.5112 19.0804 20.0856 19.2557C19.6601 19.4309 19.173 19.228 18.9978 18.8024L18.2281 16.9332L14.0649 24.5658C13.9392 24.7964 13.7121 24.9541 13.4521 24.9916C13.1922 25.029 12.9298 24.9417 12.7441 24.756L10.2283 22.2402L7.1817 28.3334H14.9317C15.3919 28.3334 15.765 28.7065 15.765 29.1668C15.765 29.627 15.3919 30.0001 14.9317 30.0001H5.83333C5.54452 30.0001 5.2763 29.8505 5.12446 29.6049C4.97262 29.3592 4.95882 29.0524 5.08798 28.7941L9.25464 20.4607C9.37444 20.2212 9.6021 20.0538 9.86652 20.0108C10.1309 19.9679 10.3998 20.0548 10.5893 20.2442L13.1351 22.79L17.6018 14.601C17.7556 14.319 18.0578 14.1505 18.3786 14.168Z"
        fill="#707578"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33333 9.99992C7.41286 9.99992 6.66667 10.7461 6.66667 11.6666C6.66667 12.5871 7.41286 13.3333 8.33333 13.3333C9.25381 13.3333 10 12.5871 10 11.6666C10 10.7461 9.25381 9.99992 8.33333 9.99992ZM5 11.6666C5 9.82564 6.49238 8.33325 8.33333 8.33325C10.1743 8.33325 11.6667 9.82564 11.6667 11.6666C11.6667 13.5075 10.1743 14.9999 8.33333 14.9999C6.49238 14.9999 5 13.5075 5 11.6666Z"
        fill="#707578"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.833333C0 0.373096 0.373096 0 0.833333 0H19.1667C19.3877 0 19.5996 0.0877974 19.7559 0.244078L28.0893 8.57741C28.2455 8.73369 28.3333 8.94565 28.3333 9.16667V15.8333C28.3333 16.2936 27.9602 16.6667 27.5 16.6667C27.0398 16.6667 26.6667 16.2936 26.6667 15.8333V9.51185L18.8215 1.66667H1.66667V35H17.5C17.9602 35 18.3333 35.3731 18.3333 35.8333C18.3333 36.2936 17.9602 36.6667 17.5 36.6667H0.833333C0.373096 36.6667 0 36.2936 0 35.8333V0.833333Z"
        fill="#707578"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1663 0C19.6266 0 19.9997 0.373096 19.9997 0.833333V8.33333H27.4997C27.9599 8.33333 28.333 8.70643 28.333 9.16667C28.333 9.6269 27.9599 10 27.4997 10H19.1663C18.7061 10 18.333 9.6269 18.333 9.16667V0.833333C18.333 0.373096 18.7061 0 19.1663 0Z"
        fill="#707578"
      />
    </svg>
  );
}
